import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DateUtils } from 'src/app/_helpers/date-utils';
import { AdminService } from '../services/admin.service';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-adm-egresados-list',
  templateUrl: './adm-egresados-list.component.html',
  styleUrls: ['./adm-egresados-list.component.css']
})
export class AdmEgresadosListComponent implements OnInit {

  searchForm;
  graduated;

  response;

  responseBySearch;

  hasSearch = false;
  constructor(private formBuilder: FormBuilder,
    private _renderer: Renderer2,
    private toast : ToastrService,
    private administradorService : AdminService,
    private router : Router) { 
  }

  async ngOnInit() 
  {
    this.searchForm = this.formBuilder.group({
      username: new FormControl('', [Validators.required,
                                      Validators.pattern(/^[^\sñ]+$/),
                                      Validators.maxLength(15),
                                      Validators.minLength(10),
                                      Validators.pattern(/^[a-zA-Z0-9]+$/)
                                    ])
    });
    await this.getEstadoPostulaciones();
  }

  get f () { return this.searchForm.controls; }

  convertDate(date:string) : string
  {
    const dateObj = new Date(date);
    return DateUtils.formatDate(dateObj);
  }

  searchUser()
  {
    if(this.searchForm.invalid)
    {
      this.toast.error('Verifique que la mátricula sea correcta','error');
      return;
    }
    this.graduated = null;
    let username = this.f.username.value.toUpperCase();
    this.administradorService.getEgresadoByUser(username).subscribe({
      next: (result) =>{
        if(result.idUsuario>0)
        {
          this.administradorService.getEstadoPostulacionesByEgresado(result.idUsuario)
          .subscribe({
            next: (result) =>{
              if(result.length>0)
              {
                this.responseBySearch = result;
              }
              else
                this.toast.error('No se encontraron postulaciones relacionadas a este egresado','');
            },
            error: (error) => {
              if(error.error.status == 404)
                return;
              this.toast.error('Ocurrio un error con el servidor','error');
            }
          });

          if(result.imgUrl)
            result.imgUrl= 'https://res.cloudinary.com/drtcnv1st/image/upload/v1678471683/Graduados/'+result.imgUrl;
          this.graduated = result;
          this.hasSearch = true;
          this.searchForm.reset();
        }
        else
          this.toast.error('No se encontró un egresado con esa mátricula','');
      },
      error: (error) => {
        if(error.error.status == 404)
          this.toast.error('No se encontró un egresado con esa mátricula','');
        else
          this.toast.error('Ocurrio un error con el servidor','error');
      }
    });
  }


  contentOverlay(event) {
    const toggleIcon = document.getElementById('sidebar-left');
    const toggle = document.getElementById('content-overlay');
    if (event.currentTarget.className === 'content-overlay show') {
      this._renderer.removeClass(toggleIcon, 'show');
      this._renderer.removeClass(toggle, 'show');
    }
  }


  async getEstadoPostulaciones() : Promise<void>{
    try {
      var data = await firstValueFrom(this.administradorService.getEstadoPostulacionesEgresado());
      if(data && data.data && data.totalRows>0)
      {
        this.response = data;
      }
      else
        this.toast.error('No se encontraron postulaciones recientes.','');
    } catch (error) {
      this.toast.error('Ocurrio un error con el servidor','error');
    }
  }


  openDetailOffer(idOferta:number) {
    if(idOferta>0)
    {
      this.router.navigate(['onlyadminaccess/ofertas/detalle'], {
        queryParams: { idOferta: JSON.stringify(idOferta) },
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }
    else
      this.toast.error('No se han podido abrir los detalles de la oferta de trabajo. Inténtalo de nuevo.','Error');
  }

  pageChange(page: any) {
    this.administradorService
      .getEstadoPostulacionesEgresadoByPage((page - 1) * this.response.pageSize)
      .subscribe((response) => {
        this.response = response;
      });
  }


  reset()
  {
    this.graduated = null;
    this.hasSearch = false;
    this.responseBySearch = null;
  }



}
